import React, { Component } from 'react';
import axios from 'axios'
import ReCAPTCHA from "react-google-recaptcha";
import { withRouter } from 'react-router-dom'
import { validEmailRegex, usernameRegex, validateForm } from './RegxConst'
import Loader from './utility/Loader';
import { TitleHeading } from './UIElements/headings/TitleHeading';
import { ButtonStyle } from './UIElements/Buttons/ButtonStyle';
import Popup from "reactjs-popup";
import listingService from './listings/service/listingService';

class Contact extends Component {

    constructor(props) {
        super(props);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.state = {
            singleListing: {},
            name: "",
            title: "",
            email_address: "",
            subject: "",
            message: "",
            errors: {
                name: '',
                email_address: '',
                subject: '',
                message: '',
            },
            isVerified: '',
            captchaInvalid: '',
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    handleChange = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        let errors = this.state.errors;
        if (value) {
            switch (name) {
                case 'name': {
                    errors.name =
                        ((value.length > 2) && (/^[a-z]/i.test(value)))
                            ? ''
                            : 'First Letter Should Be Alphabet and Minimum 3 Characters';
                    break;
                }
                case 'email_address': {
                    errors.email_address =
                        validEmailRegex.test(value)
                            ? ''
                            : 'Email is Not Valid!';
                    break;
                }
                default:
                    break;
            }

            this.setState({ errors })
        }
        else {
            errors[name] = '';
        }
    }
    onChange = value => {
        if (value != '') {
            this.setState({ isVerified: 'success', captchaInvalid: '' })
        }
    }

    recaptchaRef = React.createRef();
    contactInfo = (event) => {
        event.preventDefault();
        const data = {
            name: this.state.name,
            email: this.state.email_address,
            subject: this.state.subject,
            message: this.state.message,
            title: this.props.listing.businessName,
            listingId : this.props.listing.hpId
        }

        if (validateForm(this.state.errors) && this.state.isVerified === 'success') {
            Loader.runSpinner();
            this.closeModal();
            axios.post(process.env.REACT_APP_BACKEND_URL + '/abmgr/support/request-support  ', data).then(response => {
                Loader.stopSpinner();
                this.setState({ flag: response.data })
            }).catch(error => {
                Loader.stopSpinner();
                console.log(error, 'Contact Us Service Failed');
            })
        }
        else {
            this.setState({ captchaInvalid: 'please verify reCaptcha' })
        }
    }

    closeModal = () => {
        this.props.closeModal();
    }

    openModal = () => {

    }

    getPropsData = () => {
        const propsData = {
            businessName: this.state.business_name
        }
        return propsData;
    }

    getListingDetails = (listing) => {
        this.setState({ listingId: listing.hpId });
        //const searchCriteria = {
        //  ...this.props.search_data,
        //listingPackage: 'free',
        //showBanner: false,
        //}
        const { isSearching, searchCriteria } = this.props.location.state

        this.props.history.replace(`/single-listing/${listing.hpId}?b=${listing.businessName.replace(/\s+/g, '-').toLowerCase()}`, {
            place: 'featured',
            isViewed: this.props.viewedListings[listing.hpId],
            searchCriteria: searchCriteria,
            isSearching: true,
        });
    }

    render() {
        const { errors } = this.state;
        const listingData = this.getPropsData()
        const listing = listingService.getListingDTO(listingData);
        return (
            <div className="col-md-12" key={'popup-window'}>
                <Popup
                    open={this.props.open}
                    onClose={this.closeModal}
                    className="report_popup"
                >
                    <div className="modal">
                        <a className="close" onClick={this.closeModal}> &times; </a>
                        <div className="contact_maincontent">
                            <TitleHeading text={'Report Listing'} />
                            <div className="contact_form">
                                <form className="" onSubmit={event => { this.contactInfo(event) }}>
                                    <div className="form-group row">
                                        <div className="col-sm-2"></div>
                                        <div className="col-sm-1 contact_content text-left">
                                            <label htmlFor="title" className="contact_label">Name:</label>
                                        </div>
                                        <div className="col-sm-6">
                                            <input type="text" className="form-control" placeholder="Name *" name="name" required
                                                value={this.state.name} id="username"
                                                onChange={(event) => {
                                                    this.setState({ name: event.target.value });
                                                    this.handleChange(event)
                                                }} noValidate />
                                            <span className='error'>{errors.name}</span>
                                        </div>
                                        <div className="col-sm-3"></div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-sm-2"></div>
                                        <div className="col-sm-1 contact_content">
                                            <label htmlFor="title" className="contact_label">Email:</label>
                                        </div>
                                        <div className="col-sm-6">
                                            <input className="form-control" placeholder="Email *" name="email_address" required
                                                value={this.state.email_address} id="email"
                                                onChange={(event) => {
                                                    this.setState({ email_address: event.target.value });
                                                    this.handleChange(event)
                                                }} noValidate />
                                            <span className='error'>{errors.email_address}</span>
                                        </div>
                                        <div className="col-sm-3"></div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-sm-2"></div>
                                        <div className="col-sm-1 contact_content">
                                            <label htmlFor="title" className="contact_label">Subject:</label>
                                        </div>
                                        <div className="col-sm-6">
                                            <input type="text" className="form-control" placeholder="Subject *"
                                                id="subject" required onChange={event => { this.setState({ subject: event.target.value }) }} />
                                        </div>
                                        <div className="col-sm-3"></div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-sm-2"></div>
                                        <div className="col-sm-1 contact_content">
                                            <label htmlFor="title" className="contact_label">Listing Title:</label>
                                        </div>
                                        <div className="col-sm-6">
                                            <input type="text" className="form-control" readOnly
                                                id="title" value={this.props.listing.businessName}></input>
                                        </div>
                                        <div className="col-sm-3"></div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-sm-2"></div>
                                        <div className="col-sm-1 contact_content">
                                            <label htmlFor="title" className="contact_label">Message:</label>
                                        </div>
                                        <div className="col-sm-6">
                                            <textarea className="form-control" placeholder="Message *" rows="5" id="message" required
                                                onChange={event => { this.setState({ message: event.target.value }) }}></textarea>
                                        </div>
                                        <div className="col-sm-3"></div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-1"></div>
                                        <div className="col-sm-2"></div>
                                        <div className="col-sm-6">
                                            <span className='error'>{this.state.captchaInvalid}</span>
                                            <ReCAPTCHA
                                                //stoken
                                                ref={this.recaptchaRef}
                                                onChange={this.onChange}
                                                sitekey="6LfiH78UAAAAAESBlQa8G0s-AUEoKo3KPLqxey3D"
                                            />
                                        </div>
                                        <div className="col-sm-1"></div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-sm-6"></div>
                                        <div className="col-sm-3 btn_sendmail text-right">
                                            <ButtonStyle type="submit" className="btn">Send Email</ButtonStyle>
                                        </div>
                                    </div>
                                </form>
                                {this.state.flag === 'success' ? <div className="contact_rply"><p className='text-enter'>Thank you for reporting this to AajuBaaju eClassifieds. We will look into the issue.</p></div> : null}
                            </div>
                        </div>
                    </div>
                </Popup>
            </div>
        )
    }
}

export default withRouter(Contact);